import {Component, OnInit} from '@angular/core';
import {AssetsService} from "../services/assets.service";
import {BankService} from "../services/bank.service";
import {Router} from "@angular/router";
import {NotificationsService} from "angular2-notifications";
import {PagerserviceService} from "../services/pagerservice.service";
import {PuserserviceService} from "../services/puserservice.service";
import {UserService} from "../services/user.service";
import {ExchangeService} from "../services/exchange.service";
import {Ng4LoadingSpinnerService} from "ng4-loading-spinner";

@Component({
    selector: 'app-order',
    templateUrl: './order.component.html',
    styleUrls: ['./order.component.css']
})
export class OrderComponent implements OnInit {
    /*store all transaction list variable*/
    orderslist: Array<any>;
    /* Search variables */
    FilPerpage: number;
    FilPage: number;
    filter: Boolean;
    /************************************/
    // pager Number
    pager: number;
    Tpager: number;

    // pager object
    pager1: any = {};

    //search option
    search = '';
    statusoption = '';

    constructor(private router: Router,
                private assetService: AssetsService,
                private userService: UserService,
                private exchangeService: ExchangeService,
                private pagerService: PagerserviceService,
                private notifSer: NotificationsService,
                private pusherService:PuserserviceService,
                private spinnerService: Ng4LoadingSpinnerService) {
    }

    ngOnInit() {
        if (!this.userService.isLoggedIn()) {
            this.router.navigateByUrl('/index');
        } else {
            this.FilPerpage = 10;
            this.FilPage = 1;
            this.pager = 1;
            this.getOrderList();
            this.exchangeService.NewOrderEvent.subscribe(price => {
                this.getOrderList();
            })
            this.exchangeService.CompleteOrderEvent.subscribe(price => {
                this.getOrderList();
            })
            this.exchangeService.FreezedOrderEvent.subscribe(price => {
                this.getOrderList();
            })
        }
    }
    getOrderList() {
        // this.spinnerService.show();
        // this.exchangeService.getOrderlist(this.FilPerpage, this.FilPage, this.search).subscribe((success) => {
        //     if (success.status) {
        //         this.orderslist = success.orders;
        //         this.Tpager = success.pages;
        //         this.setPage(this.FilPage);
        //     }
        //     this.spinnerService.hide();
        // }, (error) => {
        //     this.spinnerService.hide();
        //     this.notifSer.error(
        //         'Error',
        //         error.error.message,
        //         {
        //             timeOut: 3000,
        //             showProgressBar: true,
        //             pauseOnHover: false,
        //             clickToClose: true,
        //             maxLength: 50
        //         }
        //     )
        // })
    }
    SearchOrderStatus(target){
        // this.spinnerService.show();
        // this.statusoption = target.target.value;
        // this.exchangeService.getOrderlist(this.FilPerpage, this.FilPage, this.statusoption).subscribe((success) => {
        //     if (success.status) {
        //         this.orderslist = success.orders;
        //         this.Tpager = success.pages;
        //         this.setPage(this.FilPage);
        //     }
        //     this.spinnerService.hide();
        // }, (error) => {
        //     this.spinnerService.hide();
        //     this.notifSer.error(
        //         'Error',
        //         error.error.message,
        //         {
        //             timeOut: 3000,
        //             showProgressBar: true,
        //             pauseOnHover: false,
        //             clickToClose: true,
        //             maxLength: 50
        //         }
        //     )
        // })
    }
    SearchOrders(target){
    //     this.spinnerService.show();
    //     this.search = target.target.value;
    //     this.exchangeService.getOrderlist(this.FilPerpage, this.FilPage, this.search).subscribe((success) => {
    //         if (success.status) {
    //             this.orderslist = success.orders;
    //             this.Tpager = success.pages;
    //             this.setPage(this.FilPage);
    //         }
    //         this.spinnerService.hide();
    //     }, (error) => {
    //         this.spinnerService.hide();
    //         this.notifSer.error(
    //             'Error',
    //             error.error.message,
    //             {
    //                 timeOut: 3000,
    //                 showProgressBar: true,
    //                 pauseOnHover: false,
    //                 clickToClose: true,
    //                 maxLength: 50
    //             }
    //         )
    //     })
    }

    setPage(page: number) {
        // get pager object from service
        this.pager1 = this.pagerService.getPager(this.Tpager, page);
    }

    setPageOnClick(page: number) {
        this.pager = page;
        this.FilPage = this.pager;
        this.getOrderList();
    }

}



// WEBPACK FOOTER //
// ./src/app/order/order.component.ts